/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const quickOrderCartForm = {
  entriesWereAgregared: '({{{ quantity }}) {{ product }} foi adicionado ao carrinho',
  entryWasAdicionared: '{{{ product }} foi adicionado ao carrinho',
  noResults: 'Não encontramos nenhum produto',
  stockLevelReached: 'O nível máximo de stock foi atingido',
  title: 'Pedido rápido',
  productCodePlaceholder: 'Digite o ID',
  entryProdutoCode: 'Tipo ou ID de Pedido Rápido do Produto',
  quantity: 'Quantidade de pedido rápido',
  addToCart: 'Adicionar produto ao pedido rápido',
  add: 'Adicionar',
  product: 'Produto',
  products: 'Produtos',
  productCodeLabel: 'Identificação do produto',
  quantityLabel: 'Quantidade',
};

export const quickOrderForm = {
  placeholder: 'Insira o nome ou código do produto',
  searchBoxLabel:
    'Insira o nome ou código do produto para quick order. Você pode adicionar até {{{ limit }} produtos por pedido.',
  listLimitReached: 'O limite de produtos foi atingido.',
  id: 'IDENTIFICAÇÃO {{ id }}',
  noResults: 'Nenhum resultado foi encontrado',
  addProduto: 'Adicionar produto {{{ product }}',
  initialDescription:
    'Quando os resultados do preenchimento automático estiverem disponíveis, use as setas para cima e para baixo para revisar e insira para selecionar.',
  productsResults: '{{{ count }} Os produtos estão disponíveis.',
  quickOrderSearch: 'Encontre o produto para um pedido rápido',
  outOfStockMessage: 'O produto (#{{code}}) está esgotado.',
};

export const quickOrderList = {
  addToCart: 'Adicionar ao carrinho',
  emptyList: 'Lista vazia',
  header: 'Adicionar Produtos/SKUs',
  subHeader: 'Você pode adicionar até {{{ limit }} SKUs válidos por vez.',
  errorProceedingToCart: 'Erro ao prosseguir para o carrinho.',
  warningProceedingToCart: 'Aviso prosseguindo para o carrinho.',
  successfullyAdicionaredToCart: 'Adicionado com sucesso ao carrinho.',
  errors: {
    productIsOutOfStock: '{{{ name }} (#{{code}}) está esgotado.',
    reviewErrors: 'Por favor, revise esses erros.',
    listIsFull:
      'A lista está cheia, adicione esses {{{ count }} produtos ao carrinho para continuar.',
    nonPurchasableError: 'O produto {{{ name }} não pode ser comprado',
    outOfStockErrorFound: '{{count}} O produto esgotado não foi adicionado.',
    outOfStockErrorFound_other:
      '{{count}} Nenhum produto fora de stock foi adicionado.',
  },
  warnings: {
    productWasReduced:
      'O valor de {{{ name }} (#{{code}}) foi reduzido para {{{ quantityAdded}}.',
    reviewWarnings: 'Por favor, revise esses avisos.',
    reduceWarningFound: '{{count}} A quantidade de produto foi reduzida..',
    reduceWarningFound_other: '{{count}} A quantidade de produto foi reduzida..',
  },
  successes: {
    productAdicionaredToCart: '{{{ name }} (#{{code}}) foi adicionado ao carrinho.',
    addedToCartFound: '{{{ count }} O produto foi adicionado ao carrinho.',
    addedToCartFound_other: '{{{ count }} Os produtos foram adicionados ao carrinho.',
  },
  informations: {
    addProductoBeforeAgregaringToCart:
      'Adicione produtos à lista antes de adicioná-los ao carrinho.',
  },
  undo: 'DESFAZER',
  revokeUndo: 'Revoked product "{{name}}" deletion.',
  productWasDeleted: 'Produto "{{ name }}" moved to trash.',
};

export const quickOrderTable = {
  product: 'Produto',
  id: 'IDENTIFICAÇÃO',
  price: 'Preço',
  quantity: 'Quantidade',
  itemPreço: 'Preço do artigo',
  qty: 'Quantidade',
  actions: 'Ações',
  inStock: 'Em stock',
  lowStock: 'Baixo stock',
  outOfStock: 'Sem stock',
  listCleared: 'Lista de pedidos rápida apagada',
  addedtoCart: 'Uma lista rápida de pedidos foi adicionada ao carrinho',
  caption: 'Conteúdo de pedido rápido.',
  length: 'Comprimento (MM)',
  sheetsPerPackage: 'Folhas/Pacote',
  packageWeight: 'Peso do Pacote (KG)',
};

export const quickOrder = {
  quickOrderCartForm,
  quickOrderForm,
  quickOrderList,
  quickOrderTable,
};
